import DOMPurify from "dompurify";

export function RenderHtml({ html }: { html?: string | null }) {
  if (!html) return <div className="text-gray-500">No description provided</div>;

  const cleanHtml = DOMPurify.sanitize(html);

  return (
    <div
      className="prose max-w-none"     // optional tailwind/typography helper
      dangerouslySetInnerHTML={{ __html: cleanHtml }}
    />
  );
}
